// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bag img[data-v-13ee00e8]{min-width:50px;max-height:50px;width:auto;height:auto}.bag a[data-v-13ee00e8]{color:inherit}.bag[data-v-13ee00e8]  .col-price{min-width:80px}.bag[data-v-13ee00e8]  .col-product-name{overflow-wrap:anywhere}.bag[data-v-13ee00e8]  table tr td{vertical-align:middle}.stacked-image[data-v-13ee00e8]{display:none}@media only screen and (max-width: 375px){[data-v-13ee00e8] .col-image{display:none}.stacked-image[data-v-13ee00e8]{display:block}}", ""]);
// Exports
module.exports = exports;
